export const COOKIE_TOKEN_NAME = process.env.NEXT_PUBLIC_COOKIE_TOKEN_NAME!;
export const COOKIE_REFRESH_TOKEN_NAME =
  process.env.NEXT_PUBLIC_COOKIE_REFRESH_TOKEN_NAME!;
export const COOKIE_BRIDGE_TOKEN_NAME =
  process.env.NEXT_PUBLIC_COOKIE_BRIDGE_TOKEN_NAME!;
export const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL!;
export const HRIS_API_BASE_URL = process.env.NEXT_PUBLIC_HRIS_API_BASE_URL!;

export const COOKIE_ME_COMPANY = 'COOKIE_ME_COMPANY';
